<template>
  <div class="container page">
    <van-nav-bar :title="$t('my.task_record')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />

        <div v-else class="item_list" v-for="(v, key) in list" :key="key">
          <div class="lottery_info">
            <van-image class="cover" :src="v.ico">
              <template v-slot:loading>
                <van-loading type="spinner" />
              </template>
            </van-image>
            <span class="period-number">{{ v.expect }}</span>
            <span class="period-number">{{ v.name }}</span>
          </div>

          <div class="recent">
            <div class="kuaisan-ball left">
              <div>
                <div class="recentRow">
                  <span class="recentLabel">{{ $t("reservation.curr_choose") }}</span>
                  <span v-if="v.betTypeText" class="ressquareBox">{{ v.betTypeText }}</span>
                  <span v-else class="ressquareBox">-</span>
                </div>

                <div class="recentRow">
                  <span class="recentLabel">{{ $t("reservation.result") }}</span>
                  <template v-if="v.showResult">
                    <span class="ressquareBox">{{ v.sizeText }}</span>
                    <span class="ressquareBox">{{ v.doubleText }}</span>
                  </template>
                  <template v-else>
                    <span class="ressquareBox">-</span>
                  </template>
                </div>
              </div>
            </div>
          </div>

          <div class="time">
            <span>{{ $t("reservation.order_time") }}：{{ formatLocalTime(v.create_time) }}</span>
          </div>
          <div class="time">
            <span>{{ $t("reservation.settle_time") }}：{{ formatLocalTime(v.update_time, v.update_time_text) }}</span>
          </div>
          <div class="time">
            <span>{{ $t("reservation.verify_amount") || "認証金額" }}：{{ v.money }}</span>
          </div>

          <div v-if="v.verifyText" class="verify-row">
            <span :class="v.verifyClass">{{ v.verifyText }}</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: []
    };
  },
  methods: {
    back() {
      return window.history.back();
    },

    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.getUserGameList();
        this.isLoading = false;
      }, 500);
    },

    getCurrentLang() {
      const rawLang = (localStorage.getItem("lang") || "ja").toLowerCase();

      if (rawLang.startsWith("zh")) return "zh";
      if (rawLang.startsWith("en")) return "en";
      if (rawLang.startsWith("ja")) return "ja";
      if (rawLang.startsWith("ko")) return "ko";
      if (rawLang.startsWith("kr")) return "ko";

      return "ja";
    },

    formatLocalTime(timestamp, fallbackText = "") {
      const ts = Number(timestamp);

      if (!ts) {
        return fallbackText || "-";
      }

      const date = new Date(ts * 1000);

      if (isNaN(date.getTime())) {
        return fallbackText || "-";
      }

      const Y = date.getFullYear();
      const M = String(date.getMonth() + 1).padStart(2, "0");
      const D = String(date.getDate()).padStart(2, "0");
      const h = String(date.getHours()).padStart(2, "0");
      const m = String(date.getMinutes()).padStart(2, "0");
      const s = String(date.getSeconds()).padStart(2, "0");

      return `${Y}-${M}-${D} ${h}:${m}:${s}`;
    },

    getLangText(key, lang) {
      const langMap = {
        rose: {
          zh: "玫瑰",
          en: "Rose",
          ja: "バラ",
          ko: "장미"
        },
        lily: {
          zh: "百合",
          en: "Lily",
          ja: "ユリ",
          ko: "백합"
        },
        balloon: {
          zh: "气球",
          en: "Balloon",
          ja: "風船",
          ko: "풍선"
        },
        fireworks: {
          zh: "烟花",
          en: "Fireworks",
          ja: "花火",
          ko: "불꽃놀이"
        }
      };

      return (langMap[key] && langMap[key][lang]) || "";
    },

    getRawBetType(item) {
      return String(item.type || "").trim();
    },

    getBetTypeText(item, lang) {
      const rawType = this.getRawBetType(item).toLowerCase();

      const map = {
        big: {
          zh: "玫瑰",
          en: "Rose",
          ja: "バラ",
          ko: "장미"
        },
        besar: {
          zh: "玫瑰",
          en: "Rose",
          ja: "バラ",
          ko: "장미"
        },
        small: {
          zh: "百合",
          en: "Lily",
          ja: "ユリ",
          ko: "백합"
        },
        kecil: {
          zh: "百合",
          en: "Lily",
          ja: "ユリ",
          ko: "백합"
        },
        one: {
          zh: "烟花",
          en: "Fireworks",
          ja: "花火",
          ko: "불꽃놀이"
        },
        ganjil: {
          zh: "烟花",
          en: "Fireworks",
          ja: "花火",
          ko: "불꽃놀이"
        },
        two: {
          zh: "气球",
          en: "Balloon",
          ja: "風船",
          ko: "풍선"
        },
        genap: {
          zh: "气球",
          en: "Balloon",
          ja: "風船",
          ko: "풍선"
        }
      };

      return rawType
        .split(",")
        .map(type => {
          const t = type.trim();
          if (map[t] && map[t][lang]) return map[t][lang];
          if (/^\d+$/.test(t)) return t;
          return "";
        })
        .filter(Boolean)
        .join(",");
    },

    canShowResult(item) {
      const opencode = Array.isArray(item.opencode) ? item.opencode : [];
      return Number(item.status) === 1 && opencode.length >= 3;
    },

    getSizeText(sum, lang) {
      if (sum >= 11 && sum <= 18) {
        return this.getLangText("rose", lang);
      }

      if (sum >= 3 && sum <= 10) {
        return this.getLangText("lily", lang);
      }

      return "";
    },

    getDoubleText(sum, lang) {
      if (sum % 2 === 0) {
        return this.getLangText("balloon", lang);
      }

      return this.getLangText("fireworks", lang);
    },

    getVerifyText(item) {
      if (Number(item.status) !== 1) {
        return "";
      }

      const lang = this.getCurrentLang();
      const isWin = Number(item.data && item.data[0] ? item.data[0].is_win : item.is_win);

      const textMap = {
        success: {
          zh: "認證成功",
          en: "Verification successful",
          ja: "認証が完了しました",
          ko: "인증에 성공했습니다"
        },
        fail: {
          zh: "認證失敗",
          en: "Verification failed",
          ja: "認証に失敗しました",
          ko: "인증에 실패했습니다"
        }
      };

      if (isWin === 1) {
        return textMap.success[lang] || textMap.success.ja;
      }

      if (isWin === 2) {
        return textMap.fail[lang] || textMap.fail.ja;
      }

      return "";
    },

    getVerifyClass(item) {
      if (Number(item.data && item.data[0] ? item.data[0].is_win : item.is_win) === 1) {
        return "verify-success";
      }
      if (Number(item.data && item.data[0] ? item.data[0].is_win : item.is_win) === 2) {
        return "verify-fail";
      }
      return "";
    },

    getUserGameList() {
      this.$http({
        method: "get",
        url: "user_get_game_list"
      }).then(res => {
        if (res.code === 200) {
          const lang = this.getCurrentLang();

          this.list = (res.data || []).map(item => {
            const showResult = this.canShowResult(item);
            const opencode = showResult && Array.isArray(item.opencode) ? item.opencode : [];
            const sum = showResult
              ? Number(opencode[0] || 0) +
                Number(opencode[1] || 0) +
                Number(opencode[2] || 0)
              : 0;

            return {
              ...item,
              betTypeText: this.getBetTypeText(item, lang),
              showResult,
              sizeText: showResult ? this.getSizeText(sum, lang) : "",
              doubleText: showResult ? this.getDoubleText(sum, lang) : "",
              verifyText: this.getVerifyText(item),
              verifyClass: this.getVerifyClass(item)
            };
          });
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    }
  },

  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserGameList();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}

.container .main {
  position: relative;
  overflow: auto;
  background-color: #f2f2f5;
  height: 100%;
  padding: 0 10px;
}

.item_list {
  padding: 15px 15px;
  margin: 30px 10px;
  background: #fff;
  border-radius: 10px;
  line-height: 60px;
}

.item_list .time span {
  flex: 1;
  font-size: 25px;
  font-weight: 500;
  color: #000;
}

.item_list .cover {
  width: 60px;
  height: 60px;
  -o-object-fit: cover;
  object-fit: cover;
}

.item_list .period-number {
  margin-left: 50px;
  margin-right: 10px;
  height: 50px;
  line-height: 60px;
  font-size: 35px;
  font-weight: 700;
  color: #000;
}

.item_list .lottery_info {
  display: flex;
}

.recent {
  display: flex;
  align-items: center;
  min-height: 120px;
}

.recentRow {
  display: flex;
  align-items: center;
  margin: 10px 0;
  flex-wrap: wrap;
}

.recentLabel {
  font-size: 28px;
  color: #000;
  min-width: 150px;
}

.kuaisan-ball .left {
  justify-content: flex-start;
}

.kuaisan-ball {
  flex: 1;
  display: flex;
  align-items: center;
}

.ressquareBox {
  border-radius: 16px;
  padding: 0 16px;
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
  color: #fff;
  height: 7vw;
  line-height: 7vw;
  text-align: center;
  font-size: 3vw;
  font-weight: 700;
  margin-left: 20px;
  min-width: 13vw;
}

.verify-row {
  margin-top: 8px;
}

.verify-row span {
  font-size: 25px;
  font-weight: 500;
}

.verify-success {
  color: #07c160;
}

.verify-fail {
  color: #ee0a24;
}
</style>